import React from "react";
import InstructMenu from "../components/menu/general/InstructMenu";

const TabelPengajaran = () => {
  return <InstructMenu />;
};
export default TabelPengajaran;
